import { throttle } from 'lodash';

import storage from '../storage';
import request from '../request';

const { REACT_APP_API_URL: apiUrl } = process.env;

const saveSession = async (userId, token, { referrer, screenWidth }) => {
  const session = {
    referrer: referrer || document.referrer,
    screenWidth: screenWidth || window.innerWidth,
    userId,
    url: window.location.href,
  };

  const sessionId = storage.local.getItem('CheckoutPage.sessionId');

  const url = `${apiUrl}/sessions/${sessionId || ''}`;

  const response = await request(url, token, {
    body: JSON.stringify(session),
    method: 'POST',
  });

  if (response) {
    storage.local.setItem('CheckoutPage.sessionId', response.data._id);
  }
};

const sessionTracker = (
  userId,
  token,
  details = { referrer: '', screenWidth: '' },
) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const throttledSaveSession = throttle(
    () => saveSession(userId, token, details),
    5000,
  );

  saveSession(userId, token, details);

  window.addEventListener('click', throttledSaveSession);
  window.addEventListener('keydown', throttledSaveSession);
  window.addEventListener('focus', throttledSaveSession);
};

export default sessionTracker;
